import React, { useContext, useEffect, useState } from 'react';
import { FaBars, FaSearch, FaUserCircle } from 'react-icons/fa';
import '../../styles/components-styles/header-styles/MainDashboardHeader.css';
import { SidebarContext } from '../../contexts/SidebarContext';

function MainDashboardHeader() {
    const { toggleSidebar, toggleShowUserProfileSidebar, toggleSmallScreenSidebar } = useContext(SidebarContext);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    
  
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
            console.log('Window width:', window.innerWidth);
        };
        
        window.addEventListener('resize', handleResize);
        
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    
    //     useEffect(() => {
    //         if (windowWidth <= 600) {
    //             setShowSidebar(false)
    //         }
    //         // if (windowWidth >= 600) {
    //         //     setShowSidebar(false)
    //         // }
    //     }, [windowWidth]);


    return (
        <header className="main-dashboard-header">
            {/* Hamburger Menu Icon */}
            <div className="main-dashboard-header__icon-container">
                <FaBars
                    className="main-dashboard-header__icon"
                    onClick={() => {
                        if (windowWidth <= 600) {
                            toggleSmallScreenSidebar();
                        } else {
                            toggleSidebar();
                        }
                    }}
                />
            </div>

            {/* Search Box */}
            {/* <div className="main-dashboard-header__search-container">
                <input
                    type="text"
                    className="main-dashboard-header__search-input"
                    placeholder="Search..."
                />
                <FaSearch className="main-dashboard-header__search-icon" />
            </div> */}

            {/* User Account Icon */}
            <div className="main-dashboard-header__icon-container">
                <FaUserCircle 
                    className="main-dashboard-header__icon"
                    onClick={() => {
                        toggleShowUserProfileSidebar()
                    }}  
                />
            </div>
        </header>
    );
}

export default MainDashboardHeader;
